import React from "react"

import MetaCarousel from "@components/MetaCarousel"
import Card from "@components/Card"
import { useBreakpoints } from "@hooks/useBreakpoints"
import { useCaseStudiesEach } from "../../../hooks/siteURLs"

const CardsCarrousel = params => {
  let background = "bg-dblue"
  const { isMobile, is1750 } = useBreakpoints()
  const url = useCaseStudiesEach();

  switch (params.theme) {
    case "blue-bg":
      background = "bg-dblue"
      break
    default:
      break
  }

  const { allCaseStudies , dataEvent } = params

  const itemsToShow = isMobile ? 1 : !is1750 ? 2 : 3
  const centerMode = isMobile ? false : true

  return (
    <div
      className={` mx-auto justify-center ${background} ${params.topDivClass}`}
    >
      <MetaCarousel
        itemsToShow={itemsToShow}
        adaptiveHeight={true}
        centerMode={centerMode}
        autoplaySpeed={5000}
        pauseOnHover={true}
        swipe={true}
      >
        {allCaseStudies.map((item, index) => {
          return (
            <div key={item} className={`mx-8 md:mx-0`}>
              <Card
                dataEvent={dataEvent}
                classes={{
                  container: `  
              md:h-[301px]
              `,
                }}
                img={"Case_studio_" + (index + 1) + ".png"}
                text_key={"CaseStudiesMain_Feature_" + (index + 1)}
                url={`${url}${item}`}
              />
            </div>
          )
        })}
      </MetaCarousel>
    </div>
  )
}

export default CardsCarrousel
